import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-y border-slate-800 bg-slate-900/60 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-73" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-74" data-mp="9wfq8g9f4oji">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-sky-400/40 bg-slate-950 p-8 shadow-2xl sm:p-12" data-id="element-75" data-mp="euh84xv3yhte">
          <span className="inline-flex rounded-full border border-sky-400/50 bg-slate-900 p-4 text-sky-400" data-id="element-76" data-mp="smxgme6s381p">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-77" data-mp="xlrxhal6qmj6" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-balance text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl" data-id="element-78" data-mp="12gxh22r47p43">
            Garanzia di soddisfazione <span className="text-amber-400" data-id="element-79" data-mp="25syiyof03af4">di 7 giorni</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-300" data-id="element-80" data-mp="20savgcpzdbpn">
            Se entro 7 giorni il materiale non fa per te,{' '}
            <span className="font-extrabold text-amber-400" data-id="element-81" data-mp="1vu9ebxc47mgt">ti rimborsiamo. Senza domande.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}